import axios from "axios";
// const headers = {'key':'correlationId','value':'12345'}
export const setUserGroup = (data) => {
  return { type: "SET_USER_GROUP", payload: data };
};
export const getResortData = (URL) => async (dispatch) => {
  const token = localStorage.getItem("pfJwt");
  await axios

    .get(URL, { headers: { Authorization: `Bearer ${token}` } })
    .then((response) => {
      dispatch({ type: "MAINTENANCE_RESORT_DATA", payload: response });
    })
    .catch((error) => {
      dispatch({
        type: "MAINTENANCE_ERROR_RESORT_DATA",
        payload: error.response
          ? error.response.data.title
            ? error.response.data
            : error.response.status
          : error,
      });
    });
};
export const getMarshaData = (URL) => async (dispatch) => {
  const token = localStorage.getItem("pfJwt");
  await axios
    .get(URL, { headers: { Authorization: `Bearer ${token}` } })
    .then((response) => {
      dispatch({ type: "MARSHA_CODE_DATA", payload: response });
    })
    .catch((error) => {
      dispatch({
        type: "MARSHA_ERROR_CODE_DATA",
        payload: error.response
          ? error.response.data.title
            ? error.response.data
            : error.response.status
          : error,
      });
    });
};
export const getTableData = (URL) => async (dispatch) => {
  await axios
    .get(URL)
    .then((response) => {
      dispatch({ type: "TABLE_DATA", payload: response });
    })
    .catch((error) => {
      dispatch({
        type: "TABLE_ERROR_DATA",
        payload: error.response
          ? error.response.data.title
            ? error.response.data
            : error.response.status
          : error,
      });
    });
};
